<template lang="pug">
div(v-if="$user.isAuthenticated && isAllowedRole && ($user.profile && !$user.profile.email_verified_at)")
  v-dialog(
    v-if="showBanner && $user.profile.email"
    persistent
    :value="true"
  )
    v-card.d-flex.justify-center.align-center.flex-column.text--secondary(height="90vh")
      v-btn.logout-btn(small color="error" @click="logout")
        | Выйти
        logout-icon.ml-2(right)
      .text-h2.font-weight-regular.mb-4 Ваша почта не подтверждена!
      .body-2.mb-6 Для продолжения работы в системе подтвердите свой адрес электронной почты
        span.accent--text  {{ $user.data.profile.email }}
      template(v-if="!sendEmail")
        v-fade-transition(mode="out-in")
          .d-flex.flex-wrap(v-if="!isChangeEmail")
            v-btn.mr-2(
              large
              color="primary"
              @click="verifyEmail"
            )
              | Подтвердить
            v-btn(
              large
              color="success"
              @click="isChangeEmail = true"
            )
              | Изменить адрес
          validation-observer.d-flex.flex-wrap.align-center(
            v-else
            v-slot="{ invalid }"
          )
            validation-provider(
              rules="email"
              name="электронная почта"
              v-slot="{ errors }"
            )
              ev-text-field.mr-4(
                v-model="email.new"
                toplabel
                hide-details
              )
            v-btn(
              color="success"
              @click="changeEmail"
              :disabled="isDisabledChangeBtn || invalid"
            ) Сохранить и подтвердить
      b(v-else) Письмо отправлено на указанный почтовый адрес
  v-snackbar(
    v-else-if="$user.profile.email && !$user.profile.email_verified_at"
    top
    close
    :value="showAlert"
    :timeout="-1"
    max-width="90vw"
    color="warning"
  )
    template(#action)
      v-btn(
        icon
        small
        @click="showAlert = false"
      )
        v-icon mdi-close-circle
    v-icon.mr-4 mdi-alert-outline
    span.mr-2 Ваша учетная запись будет активна 7 дней. Если в течении этого срока почта не будет подтверждена, аккаунт заблокируется.
    .mt-2.text-center
      v-btn(
        v-if="!sendEmail"
        small
        text
        @click="verifyEmail"
      )
        | Подтвердить
      b(v-else) Письмо отправлено на указанный почтовый адрес
</template>

<script>
import LogoutIcon from '@/components/icons/LogoutIcon.vue';

export default {
  name: 'EmailVerifyAlert',

  components: {
    LogoutIcon,
  },

  data() {
    return {
      showAlert: true,
      sendEmail: false,
      isChangeEmail: false,

      email: {
        old: '',
        new: '',
      },
    };
  },

  computed: {
    isExpired() {
      const tempDate = new Date(this.$user.data.created_at);
      tempDate.setDate(tempDate.getDate() + 7);
      return new Date() > tempDate;
    },

    showBanner() {
      return this.isExpired && this.$route.name !== 'verify-email';
    },

    isAllowedRole() {
      const { member, expert, trainer } = this.$conf.ROLES;
      return this.$user.hasRoles([member, expert, trainer]);
    },

    isDisabledChangeBtn() {
      return !this.email.new || this.email.new === this.email.old;
    },
  },

  created() {
    this.email.old = this.$user.data?.profile?.email || this.$user.data?.organizer?.contact_email || '';
    this.email.new = this.email.old;
  },

  methods: {
    async verifyEmail(email = '') {
      const params = {
        email: email || this.$user.profile.email,
      };

      await this.$api.user.sendVerifyEmail(params);
      this.sendEmail = true;
    },

    changeEmail() {
      this.$rHandler(this.$api.user.updateProfile({ email: this.email.new }), () => {
        this.verifyEmail(this.email.new);
        this.$toast.success('Почта изменена');
      });
    },

    async logout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.logout-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
